import type { EventCapturer } from '#src/analytics/analytics_event.ts';
import { createEventCapturer } from '#src/analytics/analytics_event.ts';
import type { ErrorService } from '#src/telemetry/errors/error_service.ts';
import posthog from 'posthog-js';

export function createPosthogEventCapturer(
  errorService: Pick<ErrorService, 'captureWarning'>,
): EventCapturer {
  return createEventCapturer(errorService, (event, properties) => {
    posthog.capture(event, properties);
  });
}
